import { API, IMG } from './site';

// Uploaded images are stored as storage paths (no leading slash, no http);
// local/default images start with '/' or 'http' and are used as-is.
export const resolveImg = (src) => {
  if (!src) return '';
  if (src.startsWith('http') || src.startsWith('/')) return src;
  return `${API}/files/${src}`;
};

// Admin "Imagini site" slots — defaults must mirror the fallbacks used by the pages
export const SITE_IMAGE_GROUPS = [
  {
    title: 'Coperte pagini (imaginea mare de sus)',
    slots: [
      { key: 'hero.home', label: 'Acasă — copertă', def: IMG.hero },
      { key: 'hero.pvc', label: 'Tâmplărie PVC — copertă', def: '/images/chapter-pvc.jpg' },
      { key: 'hero.garaj', label: 'Porți de garaj — copertă', def: '/images/hero-garaj.jpg' },
      { key: 'hero.auto', label: 'Automatizări — copertă', def: '/images/chapter-auto.jpg' },
    ],
  },
  {
    title: 'Acasă — cardurile de servicii',
    slots: [
      { key: 'home.chapter.pvc', label: 'Card Tâmplărie PVC', def: '/images/chapter-pvc.jpg' },
      { key: 'home.chapter.garaj', label: 'Card Porți de garaj', def: '/images/chapter-garaj.jpg' },
      { key: 'home.chapter.auto', label: 'Card Automatizări', def: '/images/chapter-auto.jpg' },
    ],
  },
  {
    title: 'Pagini servicii — imaginea din „Produse și soluții"',
    slots: [
      { key: 'products.pvc', label: 'Produse — Tâmplărie PVC', def: '/profile-corner.webp' },
      { key: 'products.garaj', label: 'Produse — Porți de garaj', def: IMG.garaj2 },
      { key: 'products.auto', label: 'Produse — Automatizări', def: '/images/chapter-auto.jpg' },
    ],
  },
  {
    title: 'Galerie Tâmplărie PVC (jos de tot)',
    slots: [0, 1, 2].map((i) => ({ key: `gallery.pvc.${i}`, label: `Galerie PVC — poza ${i + 1}`, def: [IMG.interior1, IMG.house1, IMG.house3][i] })),
  },
  {
    title: 'Galerie Porți de garaj (jos de tot)',
    slots: [0, 1, 2].map((i) => ({ key: `gallery.garaj.${i}`, label: `Galerie Garaj — poza ${i + 1}`, def: [IMG.garaj2, IMG.garaj3, IMG.garaj4][i] })),
  },
  {
    title: 'Galerie Automatizări (jos de tot)',
    slots: [0, 1, 2].map((i) => ({ key: `gallery.auto.${i}`, label: `Galerie Automatizări — poza ${i + 1}`, def: ['/images/chapter-auto.jpg', IMG.auto, IMG.house4][i] })),
  },
];
